export const API_URLS = {
  LOGIN: "/accounts/login/",
  REFRESH_TOKEN: "/accounts/refresh-token/",
  LOGOUT: "/accounts/logout/",
  FORGOT_PASSWORD: "/accounts/reset_password/",
  RESET_PASSWORD: "/accounts/password_reset_confirm/",
  VERIFY_EMAIL_CHANGE: "/accounts/verify-email-change/",
  // User Management
  USER_LIST: "/accounts/users/",
  USER_CREATE: "/accounts/users/create/",
  USER_DETAIL: "/accounts/users/",
  USER_UPDATE: "/accounts/users/",
  USER_DELETE: "/accounts/users/",
  PROJECT: "/project-management/project/",
  DELETE_UNCOMPLETE_PROJECT: "/project-management/project/status/",
  UPDATE_PROJECT: "/project-management/project-update/",
  COMPLIANCE: "/compliance/project-compliances/",
  USERS: "/project-management/project-users/",
  ROLES: "/project-management/project-group/",
  UPDATE_COMPLIANCE: "/compliance/project-compliances/",
  WEBSOCKET_NOTIFICATIONS: "ws/notifications/",
  NOTIFICATIONS: "/notification/",
  NOTIFICATIONS_READ_ALL: "/notification/read",
  TASKS_ACTIVITY: "/task-management/tasks-activity/",
  TASKS_LIST: "/task-management/tasks/",
  PROJECTS_LIST: "/project-management/projects/",
  PROJECT_OPTIONS: "/project-management/project-list",
  PROJECT_USERS: "/project-management/project-users/",
  PROJECT_GROUP: "/project-management/project-group/",
  PROJECT_ROSTER_LIST: "/project-management/project-details/",
  PROJECT_DETAILS: "/project-management/project-details/",
  PROJECT_DETAIL: "/project-management/project-detail/",
  PROJECT_FLIGHT: "/flight-management/booking-personnel/",
  DELETE_FLIGHT: "/flight-management/booking-personnel/",
  MOBE_REPORT: "/flight-management/mobe-report/",
  LIST_ARIPOTS: "/flight-management/airports/",
  UPDATE_PROJECT_DETAIL: "/project-management/project/",
  UPDATE_BOOKING: "/flight-management/booking/",
  DELETE_BOOKING: "/flight-management/booking/",
  FLIGHTS: "/flight-management/flights/",
  FLIGHT_PROJECT: "/flight-management/project/flight",
  LOCATIONS: "/accomodation-management/locations/",
  LOCATION: "/accomodation-management/location/",
  FLIGHT: "/flight-management/flight/",
  FLIGHT_BOOKING: "/flight-management/bookings/",
  PERSONNEL_LIST: "/personnel/project-personnel-status/",
  ALL_PERSONNEL: "/personnel/project-personnel/",
  PERSONNEL_DETAIL: "/personnel/personnel-detail/",
  PERSONNEL_CREATE: "/personnel/",
  PERSONNEL_UPDATE: "/personnel/",
  STATUS_CODES: "/personnel/status-codes/",
  ADD_STATUS_CODE: "/personnel/status-codes/create/",
  ACCOMMODATION_SETUPS: "/accomodation-management/accommodation-setups/",
  ACCOMMODATION_SETUP: "/accomodation-management/accommodation-setup/",
  ACCOMMODATION_BOOKINGS: "/accomodation-management/accommodation-bookings/",
  ACCOMMODATION_BOOKINGS_BULK_CREATE: "/accomodation-management/accommodation-bookings/bulk-create/",
  ACCOMMODATION_BOOKINGS_SPLIT: "/accomodation-management/accommodation-bookings/split/",
  ACCOMMODATION_BOOKING: "/accomodation-management/accommodation-booking/",
  ROSTERS: "/personnel/rosters/",
  ROSTER_ASSIGNMENT_BULK_CREATE: "/personnel/roster-assignments/bulk-create/",
  ROSTER_MATRIX: "/personnel/project/",
  ROSTER_DAYS_LIST: "/personnel/roster-days/",
  ROSTER_DAY_CREATE: "/personnel/roster-days/create/",
  ROSTER_DAY_BULK_CREATE: "/personnel/roster-days/bulk-create/",
  ROSTER_DAY_PATTERN_CREATE: "/personnel/roster-days/pattern-create/",
  ROSTER_DAY_BATCH_ADHOC: "/personnel/roster-days/batch-adhoc/",
  ROSTER_DAY_BULK_DELETE_ADHOC: "/personnel/roster-days/bulk-delete-adhoc/",
  ROSTER_DAY_UPDATE: "/personnel/roster-days/",
  ROSTER_DAY_DELETE: "/personnel/roster-days/",
  ROSTER_DAY_EXPIRE: "/personnel/roster-days/expire/",
  ROSTER_DAY_REVERT: "/personnel/roster-days/revert/",
  ROSTER_DAY_FLIGHT_DETAILS: "/personnel/roster-days/flight-details/",
  ROSTER_DAY_FLIGHT_DETAILS_DELETE: "/personnel/roster-days/flight-details/delete/",
  PROJECT_ASSIGNMENTS: "/personnel/project-assignments/",
  PROJECT_ASSIGNMENT_CREATE: "/personnel/project-assignments/create/",
  PROJECT_ASSIGNMENT_UPDATE: "/personnel/project-assignments/",
  PROJECT_ASSIGNMENT_DELETE: "/personnel/project-assignments/",
  PERSONNEL_PROJECT_HISTORY: "/personnel/",
  ACCOMODATIONS: "/accomodation-management/accommodations/",
  ACCOMODATION: "/accomodation-management/accommodation/",
  PERSONNEL_ACCOMODATION: "/accomodation-management/accommodation/personnel/",
  PERSONNEL_FLIGHT: "/flight-management/flight/personnel/",
  FLIGHT_LIST: "/flight-management/flights/",
  ACCOMODATION_LIST: "/accomodation-management/accommodations/",
  SWING_UPDATE: "/personnel/personnel-swing/",
  SWING_HISTORY: "/personnel/swing-update/",
  PERSONNEL_SWING_UPDATE: "/personnel/swing-update/?",
  PERSONNEL_COMPLIANCE_List: "/compliance/personnel-compliances/",
  PROJECT_COMPLIANCE: "/compliance/project-compliances/",
  UPDATE_TASK: "/task-management/task/",
  TASK_PERSONNEL: "/task-management/personnel",
  UPDATE_TASK_STATUS: "/task-management/task-status/",
  DELETE_TASK: "/task-management/task/",
  DELETE_BULK_TASK: "/task-management/tasks/bulk-delete/",
  BVA_REPORT: "/project-management/projects-bva-reports/",
  CHANGE_REQUEST: "/task-management/tasks/",
  CHECK_STATUS: "/project-management/project/status/",
  USER_GUIDE:"/project-management/user-guide",
  ARCHIVED_PROJECTS_LIST: "/project-management/projects/archived/",
  ARCHIVE_PROJECT: "/project-management/project/",
  RESTORE_PROJECT: "/project-management/project/",
  PERMANENT_DELETE_PROJECT: "/project-management/project/status/",
  // Change Requests
  CHANGE_REQUESTS: "/change-requests/change-requests/",
  CHANGE_REQUEST_CREATE: "/change-requests/change-requests/",
  CHANGE_REQUEST_DETAIL: "/change-requests/change-requests/",
  CHANGE_REQUEST_APPROVE: "/change-requests/change-requests/",
  CHANGE_REQUEST_REJECT: "/change-requests/change-requests/",
  CHANGE_REQUEST_CANCEL: "/change-requests/change-requests/",
  CHANGE_REQUEST_PENDING_COUNT: "/change-requests/change-requests/pending_count/",
  CHANGE_REQUEST_MY_STATS: "/change-requests/change-requests/my_stats/",
};
